import {Component, OnInit} from '@angular/core';
import {Post} from "../../../../domain/post";
import {PostService} from "../../../../service/forum/post.service";
import {ActivatedRoute, Router} from "@angular/router";
import {animate, style, state, trigger, transition} from "@angular/animations";
import {routerTransitionSlideToleft} from "../../../../animations/router.animations";
import {AuthService} from "../../../../../core/security/auth.service";
import {User} from "../../../../../core/domain/user";

@Component({
    selector: 'app-post-detail',
    templateUrl: './post-detail.component.html',
    styleUrls: ['./post-detail.component.scss'],
    providers: [ PostService ],
    animations:  [
        trigger('rotateIcon', [
            state("hide", style({ transform: 'rotate(0deg)' })),
            state("show" , style({ transform: 'rotate(180deg)' })),
            transition('* => *', [
                animate('100ms')
            ])
        ]),
        routerTransitionSlideToleft()
    ],
    host: {'[@routerTransition]': ''}
})
export class PostDetailComponent implements OnInit {

    public post: Post = null;
    public repliesVisible: boolean = false;
    public repliesState: string = "hide";
    public replyControl: string = "Ver respuestas";
    public liked: boolean  = false;
    public navTitle: string = "";
    public user: User = null;


    constructor(private postService: PostService,
                private authService: AuthService,
                private route: ActivatedRoute,
                private router: Router) {
    }

    ngOnInit() {
        let id = this.route.params
            .map(params => params['id']);

        id.switchMap(id => this.postService.get(+id) )
            .subscribe(p => {
                this.post = p;
                this.navTitle = p.topic.name;
            });

        this.authService.user
            .subscribe(u => this.user = u);
    }

    public getReplyCount() :string{
        if (this.post.replyCount == 0)
            return "No hay respuestas";

        if (this.post.replyCount == 1)
            return this.post.replyCount+" respuesta";

        return this.post.replyCount+" respuestas";
    }

    public getLikeCount() : string {
        if ( this.post.likeCount <= 1)
            return this.post.likeCount+"  like";

        return this.post.likeCount+"  likes";
    }

    public showReplies(e){
        e.preventDefault();
        this.repliesVisible = !this.repliesVisible;
        this.repliesState = this.repliesVisible ? "show" : "hide";
        if (this.repliesVisible) {
            this.replyControl = "Ocultar";
        } else {
            this.replyControl = "Ver respuestas";
        }
    }

    public newReply(e){
        e.preventDefault();
        this.router.navigate(["home", "post", this.post.id, "reply", "new"]);
    }

    public addLike(e){
        e.preventDefault();
        this.post.likeCount++;
        this.liked = true;
        this.postService.addLike(this.post.id).subscribe();
    }

    public editPost(e) {
        e.preventDefault();
        this.router.navigate(["home","post",this.post.id, "edit"]);
    }

    public closePost(e) {
        e.preventDefault();
        this.postService.changePostState(this.post)
            .subscribe( p => {
                this.router.navigate(["home", "post"]);
                this.post.postOpen = false;
            });
    }

    public openPost(e) {
        e.preventDefault();
        this.postService.changePostState(this.post).subscribe(p => this.post.postOpen = true);
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/forum/post/post-destail/post-detail.component.ts